module.exports = __webpack_public_path__ + "assets/48cd5f8a44607dfc9b45be06de31eb8c.svg";